module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Murgenthal_AG-715a0ab9262cf80c28b8cb51df9dded9.svg";